import "../src/resources/css/index.css";
import "../src/resources/css/home.css";
import "../src/resources/css/nota.css";
import "../src/resources/css/header.css";

import "../src/resources/css/electoral.css";

import "../src/resources/css/card-news.css"

import Script from "next/script";
// import Layout from '../src/Views/Layout/Layout';

export default function MyApp({ Component, pageProps }) {
  const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_MEASUREMENT_ID;
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>

     
        {/* <!-- Begin comScore Tag --> */}
      <Script
        async
        custom-element="amp-analytics"
        src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
        strategy="afterInteractive"
        id="comscore-amp-script"
      >
        {`
            <amp-analytics type="comscore" id="comscore">
              <script type="application/json">
                {
                  "vars": {
                    "c2": "32278281"
                  },
                  "extraUrlParams": {
                    "comscorekw": "amp"
                  }
                }
              </script>
            </amp-analytics>
          `}
      </Script>
      <Script id="comscore-script" strategy="afterInteractive">
      {` 
      var _comscore = _comscore || [];
      _comscore.push({
        c1: "2", c2: "32278281",
        options: {
          enableFirstPartyCookie: true,
          bypassUserConsentRequirementFor1PCookie: true
        }
      });
      (function () {
        var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
        s.src = "https://sb.scorecardresearch.com/cs/32278281/beacon.js";
        el.parentNode.insertBefore(s, el);
      })();
      `}
    </Script>
    <noscript>
      <img src="https://sb.scorecardresearch.com/p?c1=2&amp;c2=32278281&amp;cv=4.4.0&amp;cj=1"/>
    </noscript>
      {/* <!-- End comScore Tag --> */}

      {/* marfeel */}
      <Script
        async
        custom-element="amp-analytics"
        src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
      />

      <noscript
        dangerouslySetInnerHTML={{
          __html: `<img src="https://sb.scorecardresearch.com/p?c1=2&amp;c2=32278281&amp;cv=3.6.0&amp;cj=1">`,
        }}
      />

      <Script
        async
        src="https://secure.widget.cloud.opta.net/v3/v3.opta-widgets.js"
      />

      <Component {...pageProps} />
    </>
  );
}
